var map = {
	"./51job-icon.png": "f023",
	"./BlackBhone.png": "3742",
	"./BlackPhone.png": "e6c2",
	"./H5banner.png": "857d",
	"./Q-fang.png": "d889",
	"./advantage/38@2x.png": "163f",
	"./advantage/39@2x.png": "9455",
	"./advantage/46@2x.png": "00c3",
	"./advantage_line.png": "9377",
	"./affairs-chain.png": "aa16",
	"./alibaba-icon.png": "532f",
	"./apply-free-trial@2x.png": "083c",
	"./arrow-bot.png": "00aa",
	"./arrow-right.png": "9e6b",
	"./arrow-top.png": "a2d3",
	"./baiguoyuan-icon.png": "f413",
	"./baishi-icon.png": "2d24",
	"./bank.png": "ca4f",
	"./bankeys-downloadBg.png": "f77d",
	"./bankeys-goods.png": "0e64",
	"./bankeysH5-downloadBg.png": "8169",
	"./bankeysH5-goodsBg.png": "f6cf",
	"./bankeysH5-goodsImg.png": "fa72",
	"./bankeysPC-downloadBg.png": "7a66",
	"./bankeysPC-goodsImg.png": "a8ab",
	"./bannerForm.png": "0e19",
	"./bannerForm1.png": "0cf3",
	"./bannerForm2.png": "08b1",
	"./bannerForm3.png": "5e31",
	"./bdcz.png": "3770",
	"./bdczbtn.png": "9ac7",
	"./beike-icon.png": "b8b7",
	"./bg-dialog-success.png": "895e",
	"./bitmap.png": "6aaf",
	"./black-WX.png": "79bd",
	"./black-back.png": "077a",
	"./black-phone.png": "108c",
	"./black-rightArrow.png": "cbfb",
	"./blacklogo.png": "491d",
	"./carService-chain.png": "26db",
	"./chain-bigImg.png": "1a25",
	"./check@2x.png": "b780",
	"./chunshengcode.png": "a8d5",
	"./close.png": "d991",
	"./cma-cov.png": "b172",
	"./code.png": "50dc",
	"./con1_bottom1.png": "5c37",
	"./consumption-chain.png": "7324",
	"./cptx1.png": "283f",
	"./cptx2.png": "54f6",
	"./cptx3.png": "4913",
	"./cptx4.png": "6439",
	"./debang-icon.png": "bdb8",
	"./dot.png": "dab6",
	"./doumi-icon.png": "ad9f",
	"./download-app.png": "3663",
	"./education-chain.png": "5a03",
	"./erji.png": "2d6d",
	"./esign-chain.png": "cda7",
	"./estate-chain.png": "74fc",
	"./experience.png": "9cbf",
	"./fengtu-icon.png": "3c85",
	"./font1.png": "c3f2",
	"./font2.png": "da51",
	"./font3.png": "6199",
	"./font4.png": "fef4",
	"./footerone.png": "c074",
	"./footerthree.png": "32f9",
	"./footertwo.png": "1c62",
	"./fwcj1.png": "6398",
	"./fwcj2.png": "22d3",
	"./fwcj3.png": "91c0",
	"./fwcj4.png": "217f",
	"./fwcj5.png": "449a",
	"./gaodun-icon.png": "38b0",
	"./geely-icon.png": "05ff",
	"./get-info-jiantou.png": "4736",
	"./ggfw.png": "2aaf",
	"./glpt.png": "dd24",
	"./glptbtn.png": "e0fe",
	"./goverment-icon.png": "d152",
	"./grayNotebook.png": "94b3",
	"./grayPhone.png": "b9b0",
	"./greyPhone.png": "f3a5",
	"./guazi-icon.png": "3f0e",
	"./haikang-icon.png": "1acf",
	"./haoshihuabang-icon.png": "1a29",
	"./haoweilai-icon.png": "5d3e",
	"./head-img.png": "ccfb",
	"./hema-icon.png": "b2e3",
	"./hlw.png": "b5fb",
	"./honging-icon.png": "1790",
	"./hongxing-icon.png": "39df",
	"./house-platform.png": "9ebc",
	"./hua-icon.png": "e1b2",
	"./huawei-icon.png": "64f5",
	"./human-resources/ding_no_select.png": "aeb4",
	"./human-resources/ding_select.png": "1288",
	"./human-resources/footer_not_s.png": "dcbb",
	"./human-resources/footer_not_un.png": "7fe5",
	"./human-resources/footer_s.png": "59e3",
	"./human-resources/footer_un.png": "5d73",
	"./human-resources/not_no_select.png": "c9bf",
	"./human-resources/not_select.png": "d7c7",
	"./humanRes.png": "aa0b",
	"./identity/14@2x.png": "500b",
	"./identity/16@2x.png": "0264",
	"./identity/31@2x.png": "5f34",
	"./indexSolution-icon1.png": "8b52",
	"./indexSolution-icon10.png": "190b",
	"./indexSolution-icon11.png": "d5b9",
	"./indexSolution-icon2.png": "a10c",
	"./indexSolution-icon3.png": "7cd63",
	"./indexSolution-icon4.png": "6010",
	"./indexSolution-icon5.png": "d9f8",
	"./indexSolution-icon6.png": "caea",
	"./indexSolution-icon7.png": "ac58",
	"./indexSolution-icon8.png": "c8f1",
	"./indexSolution-icon9.png": "2511",
	"./internet-chain.png": "39f4",
	"./jiuyang-icon.png": "3b8e",
	"./jjly.png": "5bf2",
	"./lagou-icon.png": "9de8",
	"./landing-contractmanage/distribution-five.png": "bd49",
	"./landing-contractmanage/distribution-four.png": "8c16",
	"./landing-contractmanage/distribution-one.png": "922b",
	"./landing-contractmanage/distribution-six.png": "0048",
	"./landing-contractmanage/distribution-three.png": "ed1f",
	"./landing-contractmanage/distribution-two.png": "397c",
	"./landing-contractmanage/down.png": "fb7b",
	"./landing-contractmanage/four-screens.png": "0c85",
	"./landing-contractmanage/personnel-five.png": "5cac",
	"./landing-contractmanage/personnel-four.png": "240d",
	"./landing-contractmanage/personnel-one.png": "b992",
	"./landing-contractmanage/personnel-six.png": "575e",
	"./landing-contractmanage/personnel-three.png": "9e54",
	"./landing-contractmanage/personnel-two.png": "99e5",
	"./landing-contractmanage/three-screen.png": "525d",
	"./landing-contractmanage/up.png": "8f3d",
	"./landing-ofd/h5BannerBgImg.png": "9719",
	"./landing-ofd/left_btn.png": "48c2",
	"./landing-ofd/logo_four2x.png": "668c",
	"./landing-ofd/logo_one2x.png": "0cff",
	"./landing-ofd/logo_three2x.png": "f831",
	"./landing-ofd/logo_two2x.png": "53e3",
	"./landing-ofd/obj_bank2x.png": "6eec",
	"./landing-ofd/obj_guarantee2x.png": "a993",
	"./landing-ofd/obj_insurance2x.png": "2ff2",
	"./landing-ofd/obj_integrators2x.png": "11ec",
	"./landing-ofd/obj_platform2x.png": "ccb9a",
	"./landing-ofd/obj_trading2x.png": "8e51",
	"./landing-ofd/pcBannerBgImg.png": "a692",
	"./landing-ofd/plan_case2x.png": "0aed",
	"./landing-ofd/plan_ofd2x.png": "4902",
	"./landing-ofd/plan_xinchuang2x.png": "bb20",
	"./landing-ofd/qrCode.png": "5334",
	"./landing-ofd/right_btn.png": "40ad",
	"./landing-ofd/solution_five.png": "2384",
	"./landing-ofd/solution_four.png": "d7db",
	"./landing-ofd/solution_one.png": "37c0",
	"./landing-ofd/solution_seven.png": "6ee5",
	"./landing-ofd/solution_six.png": "207d",
	"./landing-ofd/solution_three.png": "3e38",
	"./landing-ofd/solution_two.png": "21e9",
	"./landing-semsign/banner-bg.png": "5d2d",
	"./landing-semsign/cover-picture.png": "31bd",
	"./landing-semsign/play-icon.png": "94e1",
	"./landing-semsign/second-picture.png": "094d",
	"./landing-semsign/second-screen.png": "106d",
	"./landing-semsign/system-four-h5.png": "34cf",
	"./landing-semsign/system-four.png": "fe55",
	"./landing-semsign/system-one-h5.png": "9e39",
	"./landing-semsign/system-one.png": "14ab",
	"./landing-semsign/system-three-h5.png": "9a33",
	"./landing-semsign/system-three.png": "0a1a",
	"./landing-semsign/system-two-h5.png": "4212",
	"./landing-semsign/system-two.png": "90e7",
	"./landing-semsign/third-bg-img.png": "2935",
	"./landing-semsign/yycj_one.png": "ddbb",
	"./landing-semsign/yycj_three.png": "e1e7",
	"./landing-semsign/yycj_two.png": "38f6",
	"./landing-semsign/yygc.png": "1028",
	"./landing-signet/cpjs_one.png": "b9fe",
	"./landing-signet/cpjs_two.png": "2dc6",
	"./landing-signet/cpys_five.png": "594a",
	"./landing-signet/cpys_four.png": "6369",
	"./landing-signet/cpys_one.png": "4671",
	"./landing-signet/cpys_six.png": "d13f",
	"./landing-signet/cpys_three.png": "4527",
	"./landing-signet/cpys_two.png": "cbdd",
	"./landing-signet/h5_banner_bg.png": "3f1b",
	"./landing-signet/h5_bottom.png": "7436",
	"./landing-signet/h5_logo_wall.png": "1339",
	"./landing-signet/h5_top.png": "c1bd",
	"./landing-signet/h5_xtrh_one.png": "f26d",
	"./landing-signet/h5_xtrh_three.png": "183c",
	"./landing-signet/h5_xtrh_two.png": "2db9",
	"./landing-signet/h5_yycj_one.png": "1f86",
	"./landing-signet/h5_yycj_three.png": "9616",
	"./landing-signet/h5_yycj_two.png": "539d",
	"./landing-signet/logo_wall.png": "afd6",
	"./landing-signet/xtrh_four.png": "cbc1",
	"./landing-signet/xtrh_one_five.png": "ec8e",
	"./landing-signet/xtrh_one_four.png": "21ab",
	"./landing-signet/xtrh_one_one.png": "7c902",
	"./landing-signet/xtrh_one_three.png": "f261",
	"./landing-signet/xtrh_one_two.png": "0adb",
	"./landing-signet/xtrh_three.png": "18d8",
	"./landing-signet/xtrh_two.png": "50bc",
	"./landing-signet/yycj_one.png": "8ecd",
	"./landing-signet/yycj_three.png": "979d",
	"./landing-signet/yycj_two.png": "7807",
	"./logistics-chain.png": "297f",
	"./logistics.png": "b2dd",
	"./logo.png": "9d64",
	"./lszz.png": "76ce",
	"./lvcheng-icon.png": "adf8",
	"./manufacturing-chain.png": "56a8",
	"./mixOsBanner-small.png": "e942",
	"./mixOsBanner.png": "104f",
	"./mixOsBannerMobile.png": "cd27",
	"./mogu-icon.png": "a895",
	"./new-footer/icon-grey-tel.png": "b307e",
	"./new-footer/icon-handshake.png": "059e",
	"./new-footer/icon-mail.png": "9566",
	"./new-footer/icon-tel.png": "f5b6",
	"./new-header/about-bg.png": "7830",
	"./new-header/collapsed-icon.png": "54a0",
	"./new-header/icon-tel.png": "09ce",
	"./new-header/menu-left-bg.png": "deca",
	"./new-header/zmhz-bg.png": "622b",
	"./ningbo-government.png": "6f4c",
	"./official-page.png": "8eb7",
	"./personAvatar.png": "5e0b",
	"./phome.png": "a545",
	"./phone.png": "1e37",
	"./power1.png": "0be6",
	"./power2.png": "7827",
	"./power3.png": "bc40",
	"./power4.png": "137f",
	"./purchase-no-data.png": "b2e0",
	"./purchase-order-package.png": "4585",
	"./qianhui-icon.png": "2bb9",
	"./qqwl.png": "5ff7",
	"./qr-code.png": "ecc3",
	"./qspt.png": "e30f",
	"./qszxbtn.png": "93f9",
	"./real-estate/ban-bj.png": "c13f",
	"./real-estate/foot-bj.png": "ff13",
	"./real-estate/logo.png": "8e69",
	"./real-estate/new_logo.png": "5228",
	"./real-estate/select-icon-1.png": "9fc7",
	"./real-estate/select-icon-2.png": "4533",
	"./real-estate/service-1.png": "d086",
	"./real-estate/service-2.png": "37da",
	"./real-estate/service-3.png": "148d",
	"./real-estate/stay-bj.png": "0ab6",
	"./red-WX.png": "a7c7",
	"./red-back.png": "4199",
	"./red-phone.png": "5832",
	"./redNotebook.png": "9defb",
	"./redPhone.png": "a8ac",
	"./redphome.png": "ca39",
	"./register.png": "b910",
	"./renrenCar-icon.png": "19ed",
	"./renzheng@2x.png": "9858",
	"./sem-api/api-five.png": "f419",
	"./sem-api/api-four.png": "5949",
	"./sem-api/api-one.png": "e69c",
	"./sem-api/api-qr-code.png": "1b60",
	"./sem-api/api-six.png": "1d5d",
	"./sem-api/api-three.png": "d662",
	"./sem-api/api-two.png": "6638",
	"./sem-api/arrange-bg.png": "e6a4",
	"./sem-api/arrange-one.png": "bc5f",
	"./sem-api/arrange-two.png": "f3b2",
	"./sem-api/banner-bg.png": "9147",
	"./sem-api/connect-one.png": "9941",
	"./sem-api/connect-two.png": "8c78",
	"./sem-api/flow-path-four.png": "8f72",
	"./sem-api/flow-path-one.png": "9ae70",
	"./sem-api/flow-path-three.png": "f575",
	"./sem-api/flow-path-two.png": "3f49",
	"./sem-api/new_content_one.png": "d3e7",
	"./sem-api/system-four-one.png": "addb",
	"./sem-api/system-four-two.png": "d19a",
	"./sem-api/system-four.png": "0262",
	"./sem-api/system-one-one.png": "c825",
	"./sem-api/system-one-two.png": "2f3d",
	"./sem-api/system-one.png": "2a51",
	"./sem-api/system-three-one.png": "39ba",
	"./sem-api/system-three-three.png": "fdf2",
	"./sem-api/system-three-two.png": "558a",
	"./sem-api/system-three.png": "acf0",
	"./sem-api/system-two-one.png": "4d30",
	"./sem-api/system-two-three.png": "5c34",
	"./sem-api/system-two-two.png": "6385",
	"./sem-api/system-two.png": "9487",
	"./sem-local/banner-bg.png": "d331",
	"./sem-local/case-left-btn.png": "e1aa",
	"./sem-local/case-right-btn.png": "afb7",
	"./sem-local/deploy-process-five.png": "01af",
	"./sem-local/deploy-process-four.png": "d70c",
	"./sem-local/deploy-process-one.png": "ab25",
	"./sem-local/deploy-process-qr-code.png": "9516",
	"./sem-local/deploy-process-seven.png": "a103",
	"./sem-local/deploy-process-six.png": "e97b",
	"./sem-local/deploy-process-three.png": "ac78",
	"./sem-local/deploy-process-two.png": "b307",
	"./sem-local/difficulty-four.png": "078e",
	"./sem-local/difficulty-one.png": "960a",
	"./sem-local/difficulty-three.png": "7c54",
	"./sem-local/difficulty-two.png": "97d4",
	"./sem-local/hybrid-cloud-one.png": "3149",
	"./sem-local/hybrid-cloud-right.png": "f3ca",
	"./sem-local/hybrid-cloud-two.png": "63df",
	"./sem-local/hybrid-cloud-wrong.png": "a6f1",
	"./sem-local/new-mode-five.png": "630d",
	"./sem-local/new-mode-four.png": "b1ae",
	"./sem-local/new-mode-one.png": "553e",
	"./sem-local/new-mode-three.png": "9143",
	"./sem-local/new-mode-two.png": "8f9c",
	"./sem-local/platform-img.png": "a313",
	"./sem-local/solution-one.png": "ff7f",
	"./sem-local/solution-three.png": "f119",
	"./sem-local/solution-two.png": "7845",
	"./sem-local/success-cases-five-bg.png": "3b09",
	"./sem-local/success-cases-five.png": "c11f",
	"./sem-local/success-cases-four-bg.png": "ec3d",
	"./sem-local/success-cases-four.png": "38cf",
	"./sem-local/success-cases-one-bg.png": "e817",
	"./sem-local/success-cases-one.png": "308f",
	"./sem-local/success-cases-three-bg.png": "8e00",
	"./sem-local/success-cases-three.png": "25de",
	"./sem-local/success-cases-two-bg.png": "349d",
	"./sem-local/success-cases-two.png": "ae80",
	"./sem-local/wudian-bg.png": "ab75",
	"./sem-local/wudian-dian.png": "3062",
	"./sem-local/wudian-wu.png": "64e9",
	"./sem-pro/H5/api_interface.png": "3a6a",
	"./sem-pro/H5/banner/banner_bg.png": "c670",
	"./sem-pro/H5/initiate_bg.png": "9abb",
	"./sem-pro/H5/pre_highLight/pre_img1.png": "4a81",
	"./sem-pro/H5/pre_highLight/pre_img2.png": "5931",
	"./sem-pro/H5/pre_highLight/pre_img3.png": "ac8a",
	"./sem-pro/H5/pre_highLight/pre_img4.png": "9482",
	"./sem-pro/H5/pre_highLight/pre_img5.png": "24a5",
	"./sem-pro/H5/pre_highLight/pre_img6.png": "9c3a",
	"./sem-pro/H5/promotion_bg.png": "f7a0",
	"./sem-pro/H5/success_exam/success_exam.png": "0d6b",
	"./sem-pro/H5/success_exam/success_exam1.png": "8ed1",
	"./sem-pro/H5/success_exam/success_exam2.png": "3930",
	"./sem-pro/H5/success_exam/success_exam3.png": "0bc0",
	"./sem-pro/api_interface/api_interface_show.png": "4c05",
	"./sem-pro/batch/batch_bg.png": "7764",
	"./sem-pro/batch/batch_launch_display.png": "d960",
	"./sem-pro/editions/basic.png": "87bd",
	"./sem-pro/editions/could_plat_bg.png": "3f86",
	"./sem-pro/editions/editions_banner.png": "772f",
	"./sem-pro/editions/premium.png": "e9eb",
	"./sem-pro/editions/professional.png": "8330",
	"./sem-pro/editions_service/api_interface_open.png": "4d9b",
	"./sem-pro/editions_service/approve_sign.png": "bc5e",
	"./sem-pro/editions_service/batch_signing.png": "355d9",
	"./sem-pro/editions_service/existing_evidence.png": "9bed",
	"./sem-pro/editions_service/foundation_signature.png": "3f53",
	"./sem-pro/editions_service/identity_authentication.png": "8bce",
	"./sem-pro/editions_service/multi-organization_space_management.png": "ba36",
	"./sem-pro/editions_service/ocr_paper_contract.png": "0d02",
	"./sem-pro/editions_service/scanning_signature.png": "6a43",
	"./sem-pro/editions_service/signature_electronics.png": "7c39",
	"./sem-pro/editions_service/smart_contract_management.png": "38e3",
	"./sem-pro/editions_service/sso_single_sign.png": "ea21",
	"./sem-pro/pre_high_light/pre_high_bg.png": "584f",
	"./sem-pro/pre_high_light/pre_high_img1.png": "d0af",
	"./sem-pro/pre_high_light/pre_high_img2.png": "9805",
	"./sem-pro/pre_high_light/pre_high_img3.png": "c20b",
	"./sem-pro/pre_high_light/pre_high_img4.png": "3ae1",
	"./sem-pro/pre_high_light/pre_high_img5.png": "1204",
	"./sem-pro/pre_high_light/pre_high_img6.png": "b6d1",
	"./sem-qa/faq-close.png": "9395",
	"./sem-qa/faq-open.png": "6edb",
	"./sem-qa/faq0.png": "25a1",
	"./sem-qa/faq1.png": "84e0",
	"./sem-qa/faq2.png": "9522",
	"./sem-qa/faq3.png": "9e14",
	"./sem-qa/faq4.png": "8735",
	"./sem-saas/banner-bg.png": "9e8a",
	"./sem-saas/flow-arrow.png": "76b5",
	"./sem-saas/flow-eight.png": "77ca",
	"./sem-saas/flow-five.png": "38c6",
	"./sem-saas/flow-four.png": "ccb5",
	"./sem-saas/flow-one.png": "409d",
	"./sem-saas/flow-path.png": "238d",
	"./sem-saas/flow-qr-code.png": "75821",
	"./sem-saas/flow-seven.png": "995a",
	"./sem-saas/flow-six.png": "4edb",
	"./sem-saas/flow-three.png": "f0cc",
	"./sem-saas/flow-two.png": "620d",
	"./sem-saas/package-title.png": "9038",
	"./sem-saas/saas-ai.png": "182b",
	"./sem-saas/serve-four.png": "19a6",
	"./sem-saas/serve-one.png": "12db",
	"./sem-saas/serve-three.png": "87b4",
	"./sem-saas/serve-two.png": "cc73",
	"./sem-signsaas/seal.png": "d0da",
	"./sem-signsaas/sealbg.png": "12c3",
	"./sem618/backtop.png": "8ecc",
	"./sem618/bgImg.png": "ad3e",
	"./sem618/customer.png": "69ba",
	"./sem618/h5_banner_bg.png": "d472",
	"./sem618/msg1.png": "5e38",
	"./sem618/msg2.png": "b87d",
	"./sem618/msg3.png": "7328",
	"./sem618/msg4.png": "3716",
	"./sem618/phone.png": "963b",
	"./sem618/power1.png": "1417",
	"./sem618/power2.png": "52b3",
	"./sem618/power3.png": "7bc8",
	"./sem618/power4.png": "ddd1",
	"./sempc-logo.png": "0407",
	"./semsal/close.png": "784d",
	"./semsal/qrcodebg.png": "4267",
	"./service-center.png": "6503",
	"./service/41@2x.png": "5754",
	"./service/43@2x.png": "9b7a",
	"./smart-contract/arrow.png": "3c3c",
	"./smart-contract/banner.png": "f86a",
	"./smart-contract/cycle-eight.png": "116b",
	"./smart-contract/cycle-five.png": "c565",
	"./smart-contract/cycle-four.png": "580a",
	"./smart-contract/cycle-one.png": "db71",
	"./smart-contract/cycle-seven.png": "ff0b",
	"./smart-contract/cycle-six.png": "d5eb",
	"./smart-contract/cycle-three.png": "0e6c",
	"./smart-contract/cycle-two.png": "3b97",
	"./smart-contract/fenxiao-five.png": "41e4",
	"./smart-contract/fenxiao-four.png": "e3c7",
	"./smart-contract/fenxiao-one.png": "428b",
	"./smart-contract/fenxiao-six.png": "6d3a",
	"./smart-contract/fenxiao-three.png": "09fc",
	"./smart-contract/fenxiao-two.png": "eece",
	"./smart-contract/renshi-five.png": "6264",
	"./smart-contract/renshi-four.png": "5afc",
	"./smart-contract/renshi-one.png": "98dc",
	"./smart-contract/renshi-six.png": "ebac",
	"./smart-contract/renshi-three.png": "b13d",
	"./smart-contract/renshi-two.png": "9a52",
	"./solution1.png": "72ed",
	"./solution2.png": "048e",
	"./solution3.png": "c18e",
	"./solution4.png": "4617",
	"./solution5.png": "2c93",
	"./solution6.png": "5bc9",
	"./solution7.png": "96b3",
	"./solution8.png": "7c90",
	"./solutionAglz.png": "02db",
	"./solutionAlbb.png": "cd38",
	"./solutionBj.png": "5db7",
	"./solutionCgcj.png": "70c1",
	"./solutionCgcjMobile.png": "fe6b",
	"./solutionCwcj.png": "bb92",
	"./solutionCwcjMobile.png": "fb41",
	"./solutionDbkd.png": "c9fd",
	"./solutionHkws.png": "13f5",
	"./solutionHxyh.png": "b122",
	"./solutionJl.png": "d5c5",
	"./solutionLb.png": "f2dc",
	"./solutionLzlj.png": "f07a",
	"./solutionNdsd.png": "77d7",
	"./solutionNjyh.png": "888b",
	"./solutionRscj.png": "bdcd",
	"./solutionRscjMobile-2.png": "a034",
	"./solutionRscjMobile.png": "d959",
	"./solutionRy.png": "9b3b",
	"./solutionStart.png": "fc3b",
	"./solutionSy.png": "f570",
	"./solutionWawj.png": "bd9c",
	"./solutionWlcj.png": "d367",
	"./solutionWlcjMobile.png": "d38e",
	"./solutionXscj.png": "12cf",
	"./solutionXscjMobile.png": "a1e7",
	"./staticH5/epidemic-present-home.png": "8be4",
	"./staticH5/header-img-old.png": "8c75",
	"./staticH5/header-img.png": "17c7",
	"./staticH5/landing-semsign/banner-bg.png": "fea1",
	"./staticH5/landing-semsign/cover-picture.png": "a55e",
	"./staticH5/landing-semsign/play-icon.png": "77c6",
	"./staticH5/landing-semsign/second-screen.png": "e6a9",
	"./staticH5/landing-semsign/system-four.png": "a918",
	"./staticH5/landing-semsign/system-one.png": "9a32",
	"./staticH5/landing-semsign/system-three.png": "dd97",
	"./staticH5/landing-semsign/system-two.png": "0f60",
	"./staticH5/yutong-icon.png": "68ec",
	"./staticH5/zhengda-icon.png": "3d49",
	"./step1.png": "ad97",
	"./step2.png": "5e99",
	"./step3.png": "0354",
	"./step4.png": "37e6",
	"./submitSus.png": "65e0",
	"./sueecss-icon.png": "c53c",
	"./suning-icon.png": "6e72",
	"./superiority1.png": "9e34",
	"./superiority2.png": "5cae",
	"./superiority3.png": "b354",
	"./superiority4.png": "ab47",
	"./superiority5.png": "72a9",
	"./superiority6.png": "6288",
	"./superiority7.png": "fb85",
	"./superiority8.png": "9a5f",
	"./suse.png": "3f08",
	"./system/api_interface_open.png": "cb33",
	"./system/approve_sign.png": "71b9",
	"./system/basic.png": "79b9",
	"./system/batch_signing.png": "1c27",
	"./system/existing_evidence.png": "04e5",
	"./system/foundation_signature.png": "8b2f",
	"./system/identity_authentication.png": "6f02",
	"./system/multi-organization_space_management.png": "08ad",
	"./system/ocr_paper_contract.png": "22c7",
	"./system/premium.png": "a86d",
	"./system/professional.png": "3bbe",
	"./system/scanning_signature.png": "8995",
	"./system/signature_electronics.png": "6017",
	"./system/smart_contract_management.png": "a2a4",
	"./system/sso_single_sign.png": "ecac",
	"./taobao-icon.png": "04e7",
	"./tiantu-icon.png": "ad1b",
	"./to-top-active.png": "3d37",
	"./to-top.png": "8a22",
	"./tongcheng-icon.png": "d4da",
	"./tourism-chain.png": "6a1e",
	"./transfer-icon.png": "4e8b",
	"./trial_dialog_close_bg.png": "31d2",
	"./triangle.png": "c8e8",
	"./tuniu-icon.png": "9281",
	"./vip-icon.png": "c656",
	"./warning.png": "e57e",
	"./wblight.png": "e3e0",
	"./wdzx.png": "f439",
	"./wdzxbtn.png": "8a80",
	"./weiboduck.png": "2909",
	"./weirenzheng@2x.png": "c391",
	"./weixinduck.png": "0cac",
	"./whiteNoteBook.png": "452b",
	"./whitePhone.png": "106dd",
	"./wx.png": "6215",
	"./wxlight.png": "fb6a",
	"./xiecheng-icon.png": "f033",
	"./xueersi-icon.png": "1de9",
	"./yinchegn-icon.png": "6684",
	"./yixuetang-icon.png": "31e8",
	"./ykzx.png": "bc19",
	"./ykzxbtn.png": "1f8c",
	"./yutong-icon.png": "e80f",
	"./zfbduck.png": "7f1f",
	"./zfblight.png": "7e8a",
	"./zhengda-icon.png": "c6c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";